import React, { useEffect } from "react"
import {
    isAuthenticated,
    getEmail
} from "../../../Helpers/Functions/Selectors/auth"
import { Redirect } from "react-router"
import { routePaths } from "../../../Routes"
import { useAppState } from "../../../Hooks/useReduxState"
import { shallowEqual, useDispatch } from "react-redux"
import { userLogout } from "../../../Actions/Auth/AuthActions"

interface AuthCheckProps {
    children: JSX.Element
}

function getSearchParams(search: URLSearchParams | null) {
    if (!search)
        return {
            email: undefined,
            collaborationId: undefined,
            rest: []
        }
    const obj: {
        email: string | undefined
        collaborationId: string | undefined
    } = { email: undefined, collaborationId: undefined }
    const rest: [string, string][] = []
    search.forEach((value, key) => {
        if (key === "email") {
            obj.email = value
        } else if (key === "collaborationId") {
            obj.collaborationId = value
        } else {
            rest.push([key, value])
        }
    })
    return {
        email: obj.email,
        collaborationId: obj.collaborationId,
        rest
    }
}

export function AuthCheck({ children }: AuthCheckProps) {
    const dispatch = useDispatch()
    const authenticated = useAppState(isAuthenticated)
    const loggedInEmail = useAppState(getEmail)
    const { redirectTo, email, collaborationId } = useAppState(state => {
        const { pathname, search } = state.router.location
        const params = getSearchParams(new URLSearchParams(search))
        const restStr =
            params.rest.length > 0
                ? params.rest.map(r => r.join("=")).join("&")
                : undefined
        return {
            redirectTo: `${pathname}${
                restStr !== undefined ? `?${restStr}` : ""
            }`,
            email: params.email,
            collaborationId: params.collaborationId
        }
    }, shallowEqual)

    useEffect(() => {
        if (
            email !== undefined &&
            loggedInEmail !== undefined &&
            loggedInEmail !== email
        ) {
            dispatch(userLogout(true))
        }
    }, [loggedInEmail, email, dispatch])

    if (authenticated) {
        return children
    }

    return (
        <Redirect
            to={routePaths.authSignIn({ redirectTo, email, collaborationId })}
        />
    )
}
